import axios from 'axios'

// pincode转城市查询
const lookupPincode = pincode =>
  axios.get('/api/v1/pincode/lookup', { params: { pincode } }).then(res => res.data)

export default { lookupPincode }
